import React from "react";

/**
 * A quiet informational panel: loading states, empty states, connection errors, guidance.
 *
 * The one shape for "the screen has something to say instead of data", so every surface says it
 * the same way. `tone="crit"` is for failures the user may need to act on; `tone="warn"` for a
 * temporary condition worth reading before acting (a unit mid-restart); everything else stays
 * muted on purpose — an empty list is not an alarm.
 */
export const Note: React.FC<{ tone?: "crit" | "warn"; className?: string; children: React.ReactNode }> = ({
    tone,
    className = "",
    children,
}) => (
    <div
        className={`rounded-md border border-[var(--line)] bg-[var(--surface)] px-5 py-4 text-[13px] leading-relaxed ${
            tone === "crit" ? "text-[var(--crit)]" : tone === "warn" ? "text-[var(--warn)]" : "text-[var(--muted)]"
        } ${className}`}
    >
        {children}
    </div>
);
